import { effect, inject, Injectable } from '@angular/core';
import { AppConfigService } from '../config/app-config.service';
import { ApmService } from '@elastic/apm-rum-angular';
import { Store } from '@ngrx/store';
import { selectCurrentUser } from '@core/auth/auth.selectors';

export const apmInitializer = () => {
  const appConfig = inject(AppConfigService);
  const apmService = inject(ApmService);
  const store = inject(Store);
  if (appConfig.config?.apmEnabled) {
    const apm = apmService.init({
      serviceName: 'SyRF Angular',
      serviceVersion: appConfig.config.gitInformationalVersion,
      distributedTracingOrigins: [appConfig.config.apiOrigin],
      serverUrl: appConfig.config.apmHost,
      environment: appConfig.config.runtimeEnvironment,
    });
    const userSignal = store.selectSignal(selectCurrentUser);
    effect(() => {
      const user = userSignal();
      apm.setUserContext(
        user
          ? {
              id: user.id,
              username: user.email,
              email: user.email,
            }
          : { id: '', username: '', email: '' }
      );
    });
  }
  return () => {};
};
